module.exports = __webpack_public_path__ + "img/sample-banking.d46e0fba.webp";